"use client";

import React from 'react';
import Head from 'next/head'
import MerchantRegisterForm from '@/components/form/merchant/MerchantRegisterForm';
import { useI18n } from '@/lib/I18nProvider';

const Merchant = () => {
    const { t } = useI18n();

    return (
        <div>
            <Head>
                <title>{t('clientPortal.register.merchantPageTitle')}</title>
            </Head>
            <section className="hero">
                <div className="hero-body mt-1 mb-1">
                    <div className="container">
                       <MerchantRegisterForm />
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Merchant